import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyA0QLOofMcpPXcvFcgyRcRY9VdBYS5XqSM",
    authDomain: "saib-ai-playground.firebaseapp.com",
    projectId: "saib-ai-playground",
    storageBucket: "saib-ai-playground.firebasestorage.app",
    messagingSenderId: "288406675721",
    appId: "1:288406675721:web:bf8fedba0f2b22181d33d8",
    measurementId: "G-ES3NDYPC6L"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export default db;